import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { ClearableInput } from "util/component/Input";

import axios from 'util/axios';

import { useDispatch, useSelector } from "react-redux";

import UserSearch from "./UserSearch";
import SelectedUser from "./SelectedUser";

import { useTranslation } from "react-i18next";
import DueDateSelector from "./DueDateSelector";
import { LoadingIndicatorBox } from "util/component/Loading";

import ModalPortal from "util/component/Modal";
import { ConfirmWithMessage, Modal } from "util/component/Modal/Modal";


const ReviewConfig = (props, _ref) => {
    const { revInfo } = props;

    const { t } = useTranslation(["page"]);
    const userSelector = useSelector((store) => store.user);
    const mainRef = useRef(null);

    const [_loading, _setLoading] = useState(false);

    const [ConfirmDom, SetConfirmDom] = useState(null);

    const [ ShowModal, SetShowModal ] = useState(null);

    const [AssignedUser, SetAssignedUser] = useState([]);
    const [RevInfo, SetRevInfo] = useState({
        revision: 0,
        tempYn: "Y",
        dueDate: null,
        round: 0,
        reviewEnd: "Y",
        reviewEndDate: null,
    });

    const chk = useRef(0);

    const onErrorHandler = () => {
        props?.onClose && props.onClose(false);
    }

    const getReviewConfig = async () => {
        _setLoading(true);
        const { geneCode } = revInfo;
        const response = await axios
            .post(process.env.REACT_APP_API + "/pcsReview/retrieveReviewRound", { geneCode })
            .catch((error) => console.error(error));
        const data = response.data.data.result;

        if(data?.reviewEnd === "N") {
            if(data?.userId !== userSelector.userId) {
                SetShowModal(<Modal onClose={onErrorHandler}>{t("commentstartednopermission")}<br />Owner: {data.userNm}</Modal>)
                return;
            }
        }

        SetAssignedUser(data?.user || []);
        SetRevInfo({
            revision: data.revision,
            round: data.round,
            dueDate: data.dueDate,
            geneCode: data.geneCode,
            reviewEnd: data.reviewEnd || "Y",
        });

        _setLoading(false);
    };

    const tmout = useRef(null);

    useEffect(() => {
        clearTimeout(tmout.current);
        if (chk.current > 0 && chk.current < 40) {
            
            if (!AssignedUser?.find((f) => f.userId === userSelector.userId)) {
                chk.current = chk.current + 10;
                setTimeout(() => onUserSelect(userSelector.userId), 500);
            }
        }

        chk.current++;
    }, [AssignedUser]);

    const HandleClose = () => {
        mainRef.current.classList.remove("show");
        mainRef.current.classList.add("hide");
        setTimeout(() => {
            props?.onClose && props.onClose(false);
        }, 1000);
    };

    const onUserSelect = async (userId) => {
        _setLoading(true);
        const { geneCode, revision, tempYn } = revInfo;
        const rev = revision.maxRevision;
        const postData = {
            userId: userSelector.userId,
            assignUser: userId,
            geneCode: geneCode,
            revision: rev,
        };
        const response = await axios.post(
            process.env.REACT_APP_API + "/pcsReview/createAssignUser",
            postData
        );
        if (response?.data.data.result.toString() === "1") await getReviewConfig();
        else console.error(response);
    };

    const removeUserConfirm = async (targetUser, msg) => {
        const { geneCode, revision, tempYn } = revInfo;
        const { userId } = userSelector;
        const postData = {
            userId,
            targetUser,
            geneCode,
            msg,
            message: msg
        };

        const response = await axios.post(
            process.env.REACT_APP_API + "/pcsReview/removeAssignUser",
            postData
        );
        if (response?.data.data.result.toString() === "1") await getReviewConfig();
        else console.error(response);
    };

    const removeUser = (e) => {
        const assignUser = e.target.closest("tr").dataset.id;
        const confirmDom = (
            <ConfirmWithMessage
                onClose={() => SetConfirmDom(null)}
                message={t("removewReviewUser")}
                onConfirm={(msg) => removeUserConfirm(assignUser, msg)}
            ></ConfirmWithMessage>
        );
        SetConfirmDom(confirmDom);
    };

    const saveConfirm = async (msg) => {
        const { geneCode, dueDate } = RevInfo;
        const { userId } = userSelector;
        const postData = {
            userId,
            geneCode,
            dueDate,
            msg,
            message: msg,
            projectNm: props.project.projectNm,
            processCd: props.project.processCd,
            assignedUser: AssignedUser
        };

        const response = await axios.post(
            process.env.REACT_APP_API + "/pcsReview/createReviewRound",
            postData
        );
        if (response?.data.data.result.toString() === "1") await getReviewConfig();
        else console.error(response);
    };

    const HandleSave = () => {
        const confirmDom = (
            <ConfirmWithMessage
                onClose={() => SetConfirmDom(null)}
                message={t("reviewstartbtn")}
                onConfirm={(msg) => saveConfirm(msg)}
            ></ConfirmWithMessage>
        );
        SetConfirmDom(confirmDom);
    };

    const stopConfirm = async (msg) => {
        const { geneCode, dueDate } = RevInfo;
        const { userId } = userSelector;
        const postData = {
            userId,
            geneCode,
            dueDate,
            msg,
            message: msg,
            projectNm: props.project.projectNm,
            processCd: props.project.processCd,
            assignedUser: AssignedUser
        };
        const response = await axios.post(
            process.env.REACT_APP_API + "/pcsReview/modifyRevFinishDt",
            postData
        );
        if (response?.data.data.result.toString() === "1") await getReviewConfig();
        else console.error(response);
    };

    const HandleStop = () => {
        const confirmDom = (
            <ConfirmWithMessage
                onClose={() => SetConfirmDom(null)}
                message={t("reviewclosebtn")}
                onConfirm={(msg) => stopConfirm(msg)}
            ></ConfirmWithMessage>
        );
        SetConfirmDom(confirmDom);
    };
    useEffect(() => {
        getReviewConfig();
        return () => {};
    }, []);

    const saveDisabled = () => {
        if (AssignedUser.length < 1) return true;

        let { dueDate } = RevInfo;

        if (!dueDate) {
            return true;
        }
        const targetD = new Date(dueDate).getTime();
        const today = new Date().getTime();

        return targetD < today;
    };

    

    return (
        <div ref={mainRef} className={"reviewer-container show"}>
            {_loading && <LoadingIndicatorBox />}
            <div
                className={"d-flex gap-10"}
                style={{ marginBottom: "10px", height: "fit-content" }}
            >
                <button className={"bpl-btn danger"} onClick={HandleClose}>
                    {t("close")}
                </button>
            </div>

            <div className={"reviewer-inner"}>
                <div>
                <h5 className={"section-title"}>Search</h5>
                <UserSearch
                    project={props.project}
                    onUserSelect={onUserSelect}
                    disabled={!(!RevInfo.reviewEnd || RevInfo.reviewEnd === "Y")}
                />
                </div>
                <div>
                <h5 className={"section-title"}>Selected Reviewer</h5>
                <SelectedUser
                    assignedUser={AssignedUser}
                    removeUser={removeUser}
                    disabled={!(!RevInfo.reviewEnd || RevInfo.reviewEnd === "Y")}
                />
                </div>
                <div>
                <h5 className={"section-title"}>Review setting</h5>
                    <div className={"custom-input"}>
                        Revision
                        <div className={"custom-input-inner"}>
                            {RevInfo.revision}
                            <span className={"bpl-temp"}></span>
                        </div>
                    </div>
                    <div className={"custom-input"}>
                        Round
                        <div className={"custom-input-inner"}>{RevInfo.round || "N/A"}</div>
                    </div>
                    <DueDateSelector
                        dueDate={RevInfo?.dueDate}
                        disabled={!(!RevInfo.reviewEnd || RevInfo.reviewEnd === "Y")}
                        setDate={(date) => {
                            SetRevInfo((OLD) => ({ ...OLD, dueDate: date }));
                        }}
                    />
                    {!RevInfo.reviewEnd || RevInfo.reviewEnd === "Y" ? (
                        <button
                            className={"bpl-btn success"}
                            style={{
                                width: "200px",
                                height: "50px",
                                fontSize: "1.3rem",
                                marginTop: "10px",
                            }}
                            onClick={HandleSave}
                            disabled={saveDisabled()}
                        >
                            {t("reviewstartbtn")}
                        </button>
                    ) : (
                        <button
                            className={"bpl-btn danger"}
                            style={{
                                width: "200px",
                                height: "50px",
                                fontSize: "1.3rem",
                                marginTop: "10px",
                            }}
                            onClick={HandleStop}
                        >
                            {t("reviewclosebtn")}
                        </button>
                    )}
                </div>
            </div>
            {ConfirmDom && <ModalPortal>{ConfirmDom}</ModalPortal>}
                            {ShowModal && <ModalPortal>{ShowModal}</ModalPortal>}
        </div>
    );
};

export default ReviewConfig;
